import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPlus, FaKey, FaFolderOpen, FaUnlockAlt } from 'react-icons/fa'; // Importing React Icons

const WalletSelection = ({setCurrentStep}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  return (
    <motion.div
      className="flex flex-col items-start  max-w-4xl mx-auto justify-center bg-[#191919] text-white h-screen md:px-4 px-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="md:text-4xl text-xl font-normal my-6">Welcome to Monero</h1>

      {/* Wallet Options */}
      <div className="space-y-6 mb-8 w-full max-w-4xl">
        {/* Create a new wallet */}
        <motion.div
          className={`p-6 border-b border-gray-800 rounded cursor-pointer ${selectedOption === 'create' ? 'bg-orange-500' : 'bg-[#2a2a2a]'}`}
          onClick={() => setSelectedOption('create')}
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex items-center gap-4">
            <FaPlus size={24} />
            <div>
              <div className="font-semibold">Create a new wallet</div>
              <p className="text-sm">Choose this option if this is your first time using Monero.</p>
            </div>
          </div>
        </motion.div>

        {/* Create a new wallet from hardware */}
        <motion.div
          className={`p-6 border-b border-gray-800 rounded cursor-pointer ${selectedOption === 'hardware' ? 'bg-orange-500' : 'bg-[#2a2a2a]'}`}
          onClick={() => setSelectedOption('hardware')}
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex items-center gap-4">
            <FaKey size={24} />
            <div>
              <div className="font-semibold">Create a new wallet from hardware</div>
              <p className="text-sm">Connect your hardware wallet to create a new Monero wallet.</p>
            </div>
          </div>
        </motion.div>

        {/* Open a wallet from file */}
        <motion.div
          className={`p-6 border-b border-gray-800 rounded cursor-pointer ${selectedOption === 'file' ? 'bg-orange-500' : 'bg-[#2a2a2a]'}`}
          onClick={() => setSelectedOption('file')}
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex items-center gap-4">
            <FaFolderOpen size={24} />
            <div>
              <div className="font-semibold">Open a wallet from file</div>
              <p className="text-sm">Import an existing .keys wallet file from your computer.</p>
            </div>
          </div>
        </motion.div>

        {/* Restore wallet from keys or mnemonic seed */}
        <motion.div
          className={`p-6 border-b border-gray-800 rounded cursor-pointer ${selectedOption === 'restore' ? 'bg-orange-500' : 'bg-[#2a2a2a]'}`}
          onClick={() => setSelectedOption('restore')}
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex items-center gap-4">
            <FaUnlockAlt size={24} />
            <div>
              <div className="font-semibold">Restore wallet from keys or mnemonic seed</div>
              <p className="text-sm">Enter your private keys or 25-word mnemonic seed to restore your wallet.</p>
            </div>
          </div>
        </motion.div>
      </div>

      <div className='flex items-start max-w-4xl mr-auto justify-start '>
        {/* Change wallet mode button */}
        <motion.button
          onClick={() => {
            setCurrentStep(4)
          }}
          className="mt-4 px-6 py-2 bg-orange-500 rounded text-sm text-white"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3 }}
        >
          Change wallet mode
        </motion.button>
      </div>
    </motion.div>
  );
};

export default WalletSelection;
